<template>
  <div id="Ocean">
    	
  </div>
</template>

<script>
import * as THREE from 'three';
import * as Stats from 'stats.js'
import * as dat from 'dat.gui';

import { Water } from 'three/examples/jsm/objects/Water';
import { Sky } from 'three/examples/jsm/objects/Sky';

import { FirstPersonControls } from '@/assets/scripts/jsm/controls/FirstPersonControls.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import {ImprovedNoise} from '@/assets/scripts/jsm/math/ImprovedNoise.js';

import normalsTexture from  '@/assets/textures/waternormals.jpg'

export default {
	props:{time:{default:7}},
   	components: {},
		data: () => ({	
			dayTime:7
		}),
		mounted(){
			vueApp=this
			init()
			running=true
			animate();
			this.dayTime=this.time
			setTimeout(this.setTime,1000)
			
			

		},
		computed:{
			debug(){
				return this.$store.getters.getDebug
			}
		},
		methods:{
			mapRange(value, low1, high1, low2, high2) {
				return low2 + (high2 - low2) * (value - low1) / (high1 - low1);
			},
			setTime(){

			
				let time= this.dayTime || 7
				
				// 12- .025
				//6 0.35
				// 18 .1
				time=Math.max(time,5)
				time=Math.min(time,20)
				//time=5
				parameters.azimuth=this.mapRange(time,20,6,0.07,.33)
				parameters.inclination=this.mapRange(Math.abs(12-time),0,7,.3,0.5)
				parameters.rayleigh=this.mapRange(Math.abs(12-time),0,7,.3,2)
				
				updateSun()
			}
		},
		watch:{
			debug(val){
				if(val){
					container.appendChild( stats.dom );
				}else{
					container.removeChild( stats.dom );
				}
			},
			time(val){
				this.dayTime=val
				setTimeout(this.setTime,2000)
			}
		},
		
		beforeDestroy(){
			running=false
			if ( gui ) gui.destroy();
		}
	};
	var vueApp
	var running=false
	var container, stats;
	var camera, scene, renderer, light ;
	var controls, water,sun;
	
    var gui
  
	var texture, worldWidth = 1024, worldDepth = 1024,
		  worldHalfWidth = worldWidth / 2, worldHalfDepth = worldDepth / 2;
    var clock = new THREE.Clock();
    var offsets
	var  localTime=7
	var parameters
	var updateSun
	function init() {
        container = document.getElementById( 'Ocean' );
		

				//

				renderer = new THREE.WebGLRenderer();
				renderer.setPixelRatio( window.devicePixelRatio );
				renderer.setSize( window.innerWidth, window.innerHeight );
				container.appendChild( renderer.domElement );

				//

				scene = new THREE.Scene();

				camera = new THREE.PerspectiveCamera( 55, window.innerWidth / window.innerHeight, 1, 20000 );
				camera.position.set( 30, 30, 100 );

				//

				sun = new THREE.Vector3();

				// Water

				var waterGeometry = new THREE.PlaneBufferGeometry( 10000, 10000 );

				water = new Water(
					waterGeometry,
					{
						textureWidth: 512,
						textureHeight: 512,
						waterNormals: new THREE.TextureLoader().load( normalsTexture, function ( texture ) {
					
					texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
				} ),
						alpha: 0.0,
						sunDirection: new THREE.Vector3(),
						sunColor: 0xffffff,
						waterColor: 0x001e0f,
						distortionScale: 3.7,
						fog: scene.fog !== undefined
					}
				);

				water.rotation.x = - Math.PI / 2;

				scene.add( water );

				// Skybox

				var sky = new Sky();
				sky.scale.setScalar( 10000 );
				scene.add( sky );

				var uniforms = sky.material.uniforms;

				uniforms[ 'turbidity' ].value = 10;
				uniforms[ 'rayleigh' ].value = 2;
				uniforms[ 'mieCoefficient' ].value = 0.005;
				uniforms[ 'mieDirectionalG' ].value = 0.8;
				uniforms[ 'showDisk' ].value = 0.00;

				parameters = {
					inclination: 0.49,
					azimuth: 0.3,
					rayleigh: 0.4, //2.0,
					mieCoefficient:0.0, //0.005,
					mieDirectionalG:0.8
				};

				var pmremGenerator = new THREE.PMREMGenerator( renderer );

				updateSun=function() {
					
					var theta = Math.PI * ( parameters.inclination - 0.5 );
					var phi = 2 * Math.PI * ( parameters.azimuth - 0.5 );
					sun.x = Math.cos( phi );
					sun.y = Math.sin( phi ) * Math.sin( theta );
					sun.z = Math.sin( phi ) * Math.cos( theta );
					sky.material.uniforms[ 'sunPosition' ].value.copy( sun );
					water.material.uniforms[ 'sunDirection' ].value.copy( sun ).normalize();
					sky.material.uniforms[ "rayleigh"].value=parameters.rayleigh
					sky.material.uniforms[ "mieCoefficient"].value=parameters.mieCoefficient
					sky.material.uniforms[ "mieDirectionalG"].value=parameters.mieDirectionalG

					scene.environment = pmremGenerator.fromScene( sky ).texture;

				}
				updateSun();

				//

				

				//

				controls = new OrbitControls( camera, renderer.domElement );
				controls.maxPolarAngle = Math.PI * 0.495;
				controls.target.set( 0, 10, 0 );
				controls.minDistance = 40.0;
				controls.maxDistance = 200.0;
				controls.update();

				//

				stats = new Stats();
				//container.appendChild( stats.dom );

				// GUI
				if(vueApp.debug){
					gui = new dat.GUI();

					var folder = gui.addFolder( 'Sky' );
					folder.add( parameters, 'inclination', 0, 0.5, 0.0001 ).onChange( updateSun );
					folder.add( parameters, 'azimuth', 0, 1, 0.0001 ).onChange( updateSun );
					folder.add( parameters, 'rayleigh', 0, 4, 0.0001 ).onChange( updateSun );
					folder.add( parameters, 'mieCoefficient', 0, 2, 0.0001 ).onChange( updateSun );
					folder.add( parameters, 'mieDirectionalG', 0, 2, 0.0001 ).onChange( updateSun );
					folder.open();

					var uniforms = water.material.uniforms;
					var folder = gui.addFolder( 'Water' );
					folder.add( uniforms.distortionScale, 'value', 0, 8, 0.1 ).name( 'distortionScale' );
					folder.add( uniforms.size, 'value', 0.1, 10, 0.1 ).name( 'size' );
					folder.add( uniforms.alpha, 'value', 0.9, 1, .001 ).name( 'alpha' );
					folder.open();
				}
				//

				window.addEventListener( 'resize', onWindowResize, false );

			}

			function onWindowResize() {

				camera.aspect = window.innerWidth / window.innerHeight;
				camera.updateProjectionMatrix();

				renderer.setSize( window.innerWidth, window.innerHeight );

			}

			function animate() {
				if(running){
				requestAnimationFrame( animate );
				render();
				console.log("OCEAN",running)
				stats.update();
				}
				

			}

			function render() {

				var time = performance.now() * 0.001;

			

				water.material.uniforms[ 'time' ].value += 1.0 / 60.0;

				renderer.render( scene, camera );

			}
			

</script>


<style scoped>
 #ocean{
	 height:100%;
 }
</style>